import { render, staticRenderFns } from "./TroskovnikBreakdown.vue?vue&type=template&id=b80fcf86"
import script from "./TroskovnikBreakdown.vue?vue&type=script&lang=js"
export * from "./TroskovnikBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports